var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3493 9.15459H2.5713V14.0416C2.5713 14.3296 2.8073 14.5656 3.0953 14.5656H6.6733C6.9613 14.5656 7.19731 14.3296 7.19731 14.0416V10.4636H9.37931V14.0416C9.37931 14.3296 9.61531 14.5656 9.90331 14.5656H13.3073C13.5953 14.5656 13.8313 14.3296 13.8313 14.0416V9.15459H15.3153C15.5243 9.15459 15.7163 9.02359 15.7953 8.83159C15.8743 8.6396 15.8303 8.41259 15.6823 8.2646L8.85732 1.34359C8.65632 1.14258 8.32532 1.13459 8.12433 1.3346L0.994336 8.2556C0.837334 8.40359 0.793331 8.6306 0.87233 8.83161C0.948326 9.03261 1.14032 9.1546 1.34933 9.1546L1.3493 9.15459ZM8.4703 2.45258L14.0553 8.10758H13.3053C13.0173 8.10758 12.7813 8.34358 12.7813 8.63158V13.5186H10.4253V9.94058C10.4253 9.65258 10.1893 9.41658 9.90129 9.41658H6.67229C6.38429 9.41658 6.14829 9.65258 6.14829 9.94058V13.5186H3.61729V8.63158C3.61729 8.34358 3.38128 8.10758 3.09328 8.10758H2.64127L8.47027 2.45258H8.4703Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.831299 0.377579)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/houseIcon.dc43b738579bed46ca522e2400fd8833.svg";
export { ForwardRef as ReactComponent };